/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchVo } from './BatchVo';
import {
    BatchVoFromJSON,
    BatchVoFromJSONTyped,
    BatchVoToJSON,
    BatchVoToJSONTyped,
} from './BatchVo';
import type { EnumOption1 } from './EnumOption1';
import {
    EnumOption1FromJSON,
    EnumOption1FromJSONTyped,
    EnumOption1ToJSON,
    EnumOption1ToJSONTyped,
} from './EnumOption1';

/**
 * 
 * @export
 * @interface AdminStockAdjustInitResVo
 */
export interface AdminStockAdjustInitResVo {
    /**
     * SKU主键ID
     * @type {number}
     * @memberof AdminStockAdjustInitResVo
     */
    skuId?: number;
    /**
     * SKU编码
     * @type {string}
     * @memberof AdminStockAdjustInitResVo
     */
    skuCode?: string;
    /**
     * 调整原因下拉项
     * @type {Array<EnumOption1>}
     * @memberof AdminStockAdjustInitResVo
     */
    reasonOptions?: Array<EnumOption1>;
    /**
     * 可调整批次列表（含货位可用量）
     * @type {Array<BatchVo>}
     * @memberof AdminStockAdjustInitResVo
     */
    batches?: Array<BatchVo>;
}

/**
 * Check if a given object implements the AdminStockAdjustInitResVo interface.
 */
export function instanceOfAdminStockAdjustInitResVo(value: object): value is AdminStockAdjustInitResVo {
    return true;
}

export function AdminStockAdjustInitResVoFromJSON(json: any): AdminStockAdjustInitResVo {
    return AdminStockAdjustInitResVoFromJSONTyped(json, false);
}

export function AdminStockAdjustInitResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustInitResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'reasonOptions': json['reasonOptions'] == null ? undefined : ((json['reasonOptions'] as Array<any>).map(EnumOption1FromJSON)),
        'batches': json['batches'] == null ? undefined : ((json['batches'] as Array<any>).map(BatchVoFromJSON)),
    };
}

export function AdminStockAdjustInitResVoToJSON(json: any): AdminStockAdjustInitResVo {
    return AdminStockAdjustInitResVoToJSONTyped(json, false);
}

export function AdminStockAdjustInitResVoToJSONTyped(value?: AdminStockAdjustInitResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'reasonOptions': value['reasonOptions'] == null ? undefined : ((value['reasonOptions'] as Array<any>).map(EnumOption1ToJSON)),
        'batches': value['batches'] == null ? undefined : ((value['batches'] as Array<any>).map(BatchVoToJSON)),
    };
}

